import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";

import { store } from "./store/index";
import App from "./App";

if (process.env.REACT_APP_SENTRY_KEY && process.env.REACT_APP_ENV !== "LOCAL") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    environment: process.env.REACT_APP_ENV,
  });
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
